import React from "react";

export default function ErrorFallback({ error }) {
  return (
    <div className="error-fallback">
      <h1>Something went wrong..</h1>
      <p className="error-msg">{error.message}</p>
    </div>
  );
}
